/* eslint-disable no-nested-ternary */
import React, { useState } from "react";

import { MdOutlinePeopleAlt } from "react-icons/md";
import { FaRegStar, FaWhatsapp } from "react-icons/fa";
import { useGetDestaques } from "services/api/Destaques/get-destaques";
import { IoIdCardOutline } from "react-icons/io5";
import { PiMicrosoftOutlookLogo } from "react-icons/pi";
import { useHistory } from "react-router-dom";
import InputRanking from "screens/leads/components/SearchRankingInput";
import CustomPagination from "components/CustomPagination";

import { HiOutlineChevronDown, HiOutlineChevronUp } from "react-icons/hi";

import { useCarometro } from "services/api/carometro/carometro-get";
import { toast } from "react-toastify";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { Tooltip } from "@mui/material";
import * as S from "./styles";
import MaterialUI from "../../../../material-UI";

import * as IconsSVG from "../../../../assets/iconsSVG";

import * as base64Img from "../../../../assets/base64";

function CarometroContent() {
  const { codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  // Manager expandido (accordion)
  const [expandedManager, setExpandedManager] = useState<string | null>(null);

  // Busca principal
  const [palavraChave] = useState<string>("");
  const [paginaAtual] = useState<number>(1);
  const [totalItensRetorno] = useState<number>(2);

  // Para saber qual id de gerente buscamos detalhe
  const [idUsuarioLider, setIdUsuarioLider] = useState<string>("");

  // Para filtrar a equipe do detalhe no front-end
  const [detailSearch, setDetailSearch] = useState<string>("");

  // 1) Primeiro fetch: lista de gerentes
  const { data: carometro, isFetching: isLoadingCarometro } = useCarometro({
    queryKey: `carometro-gerentes`,
    PalavraChave: palavraChave,
    PaginaAtual: paginaAtual,
    TotalItensRetorno: totalItensRetorno,
    enabled: true,
  });

  // 2) Segundo fetch: detalhe (equipe) de um gerente específico
  const { data: carometroDetalhe, isFetching: isLoadingCarometroDetalhe } =
    useCarometro({
      queryKey: `carometro-detalhe-gerentes`,
      IdUsuarioLider: idUsuarioLider,
      PalavraChave: palavraChave,
      PaginaAtual: paginaAtual,
      TotalItensRetorno: totalItensRetorno,
      enabled: !!idUsuarioLider,
    });

  // Divide gerentes do carometro principal em duas colunas (exemplo)
  const managersDisplayed = carometro?.data?.usuarios?.slice(0, 12) || [];

  // Função para copiar texto (e-mail, telefone etc.)
  const handleCopy = (value: string | null | undefined) => {
    if (!value) return;
    navigator.clipboard.writeText(value);
    toast.success("Copiado!");
  };

  // Expande / recolhe detalhes
  const toggleManager = async (managerId: string, manager: any) => {
    if (expandedManager === managerId) {
      // Se já está aberto, fecha o accordion
      setExpandedManager(null);
    } else {
      // Abre o accordion
      setExpandedManager(managerId);
      setDetailSearch("");

      // Se de fato for um usuário líder de equipe, buscamos o detalhe.
      // Ao atualizar o idUsuarioLider, a query (com IdUsuarioLider no queryKey
      // e enabled=!!idUsuarioLider) refaz a busca automaticamente com o id
      // correto, evitando a race de refetch com valor defasado.
      if (manager?.usuarioLiderEquipe) {
        setIdUsuarioLider(managerId);
      } else {
        // Se não for líder (mas tiver líder acima), não chamamos a API
        // e "limpamos" o idUsuarioLider para evitar exibir dados de outro manager
        setIdUsuarioLider("");
      }
    }
  };

  // Define cores de fundo conforme codigoEmpresaVendas
  const generateColors = (manager: any) => {
    switch (manager?.codigoEmpresaVendas) {
      case "1": // SELLER SUL
      case "3": // SELLER CYRELA SP
      case "5": // SELLER CYRELA RJ
      case "6": // SELLER LIVING SP
      case "7": // SELLER INTERIOR SP
      case "8": // SELLER RJ
        return "#FFF3F3";
      case "4": // VIVAZ VENDAS
        return "#F5E6F0";
      case "2": // VIVAZ HOUSE
        return "#ECECEC";
      default:
        return "#000";
    }
  };

  const generateColorsBorder = (manager: any) => {
    switch (manager?.codigoEmpresaVendas) {
      case "1": // SELLER SUL
      case "3": // SELLER CYRELA SP
      case "5": // SELLER CYRELA RJ
      case "6": // SELLER LIVING SP
      case "7": // SELLER INTERIOR SP
      case "8": // SELLER RJ
        return "#E7D2D4";
      case "4": // VIVAZ VENDAS
        return "#DEB0CF";
      case "2": // VIVAZ HOUSE
        return "#D5D5D5";
      default:
        return "#000";
    }
  };

  const permittedInfos = (manager: any) => {
    if (
      manager?.codigoEmpresaVendas === "2" || // VIVAZ HOUSE
      manager?.codigoEmpresaVendas === "4" // VIVAZ VENDAS
    ) {
      switch (codigoCargo2013) {
        case "219.840.000":
          // Superintendente
          return false;
        case "219.840.001":
          // GerenteVendas
          return false;
        case "219.840.002":
          // Corretor
          return false;
        case "219.840.003":
          // GerenteGeral
          return false;
        case "219.840.004":
          // Vendedor
          return true;
        case "219.840.005":
          // Supervisor
          return true;
        case "219.840.006":
          // EspecialistaProduto
          return true;
        case "219.840.007":
          // Recepcionista
          return true;
        default:
          return "";
      }
    }

    return true;
  };

  const formatPhone = (phone: string) => {
    if (!phone) return "";
    if (phone.length === 10)
      return phone?.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");

    return phone?.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  };

  // Define qual ícone exibir
  const generateIcons = (manager: any) => {
    switch (manager.codigoEmpresaVendas) {
      case "1": // SELLER SUL
        return base64Img.SellerBase64;
      case "3": // SELLER CYRELA SP
        return base64Img.SellerBase64;
      case "5": // SELLER CYRELA RJ
        return base64Img.SellerBase64;
      case "6": // SELLER LIVING SP
        return base64Img.SellerBase64;
      case "7": // SELLER INTERIOR SP
        return base64Img.SellerBase64;
      case "8": // SELLER RJ
        return base64Img.SellerBase64;
      case "4": // VIVAZ VENDAS
        return base64Img.VivazVendas;
      case "2": // VIVAZ HOUSE
        return base64Img.VivazHouseBase64;
      default:
        return "";
    }
  };

  // Filtro local (front-end) para a equipe (carometroDetalhe)
  const filteredDetails = React.useMemo(() => {
    if (!carometroDetalhe?.data?.usuarios) return [];
    const lowerSearch = detailSearch.toLowerCase();

    return carometroDetalhe.data.usuarios.filter((member: any) => {
      const apelido = member.apelido?.toLowerCase() || "";
      const nome = member.nome?.toLowerCase() || "";
      const email = member.email?.toLowerCase() || "";
      const telefone = member.telefone?.toLowerCase() || "";

      return (
        apelido.includes(lowerSearch) ||
        nome.includes(lowerSearch) ||
        email.includes(lowerSearch) ||
        telefone.includes(lowerSearch)
      );
    });
  }, [carometroDetalhe, detailSearch]);

  const renderManagerCard = (manager: any) => {
    const isOpen = expandedManager === manager?.idUsuario;

    return (
      <S.ManagerCard key={manager?.idUsuario}>
        {/* Cabeçalho do gerente */}
        <div
          style={{
            borderRadius: "24px",
          }}
        >
          <S.ManagerButton
            border={generateColorsBorder(manager)}
            background={generateColors(manager)}
            onClick={() => {
              if (
                manager?.usuarioLiderEquipe ||
                (manager?.usuarioLiderEquipe === false &&
                  manager?.lider !== null)
              ) {
                toggleManager(manager?.idUsuario, manager);
              }
            }}
          >
            <S.ManagerInfo>
              {manager?.urlFoto ? (
                <S.ManagerAvatar
                  src={manager.urlFoto}
                  alt={manager?.apelido || manager?.nome}
                />
              ) : (
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    border: "2px solid #808080",
                    marginLeft: "8px",
                    background: "#d3d3d3",
                  }}
                >
                  <IconsSVG.UserIcon width={30} height={30} />
                </div>
              )}

              <S.ManagerDetailsWrapper>
                <Tooltip title={manager?.apelido || manager?.nome} arrow>
                  <S.ManagerName>
                    {manager?.apelido || manager?.nome}
                  </S.ManagerName>
                </Tooltip>
                <Tooltip title={manager?.nome || manager?.apelido} arrow>
                  <S.ManagerRole>
                    {manager?.nome || manager?.apelido}
                  </S.ManagerRole>
                </Tooltip>
              </S.ManagerDetailsWrapper>

              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                {/* EMAIL */}
                <S.ContactItem
                  onClick={(event) => {
                    // Impede que o clique seja transmitido ao elemento pai
                    event.stopPropagation();
                    handleCopy(manager?.email);
                  }}
                >
                  <PiMicrosoftOutlookLogo color="#127CD6" size={24} />
                  <Tooltip title={manager?.email} arrow>
                    <S.ContactInfoText>
                      {manager?.email || "Sem e-mail"}
                    </S.ContactInfoText>
                  </Tooltip>
                </S.ContactItem>

                {/* TELEFONE */}
                {permittedInfos(manager) && (
                  <S.ContactItem
                    onClick={(event) => {
                      // Impede que o clique seja transmitido ao elemento pai
                      event.stopPropagation();
                      handleCopy(formatPhone(manager?.telefone));
                    }}
                  >
                    <FaWhatsapp color="rgb(76, 175, 80)" size={24} />
                    <Tooltip title={manager?.telefone} arrow>
                      <S.ContactInfoText>
                        {formatPhone(manager?.telefone) || "Sem telefone"}
                      </S.ContactInfoText>
                    </Tooltip>
                  </S.ContactItem>
                )}
              </div>
            </S.ManagerInfo>

            {/* Ícone da empresa e seta de expandir/recolher */}
            <div
              style={{
                gap: "30px",
                display: "flex",
                alignItems: "center",
                paddingRight:
                  manager?.usuarioLiderEquipe ||
                  (manager?.usuarioLiderEquipe === false &&
                    manager?.lider !== null)
                    ? "32px"
                    : "110px",
              }}
            >
              {manager?.codigoEmpresaVendas ? (
                <img
                  src={generateIcons(manager)}
                  alt="Logo"
                  width={150}
                  height={90}
                  style={{ objectFit: "contain" }}
                />
              ) : null}

              {manager?.usuarioLiderEquipe ||
              (manager?.usuarioLiderEquipe === false &&
                manager?.lider !== null) ? (
                isOpen ? (
                  <HiOutlineChevronUp size={48} color="#808080" />
                ) : (
                  <HiOutlineChevronDown size={48} color="#808080" />
                )
              ) : null}
            </div>
          </S.ManagerButton>
        </div>

        {/* 
          Mantemos sempre o bloco de detalhes no DOM. 
          Controlamos a altura via prop isOpen para animar o accordion.
        */}
        <S.ManagerDetails isOpen={isOpen}>
          {/* Se o manager tiver um líder, exibe as infos */}
          {manager?.lider && (
            <S.ContactInfo style={{ marginBottom: "16px" }}>
              <div
                style={{ display: "flex", gap: "16px", alignItems: "center" }}
              >
                {manager?.lider?.urlFoto ? (
                  <S.TeamMemberAvatar
                    src={manager?.lider?.urlFoto || ""}
                    alt={manager?.lider?.nome || manager?.lider?.apelido}
                  />
                ) : (
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                      background: "#d3d3d3",
                      border: "2px solid #808080",
                    }}
                  >
                    <IconsSVG.UserIcon width={20} height={20} />
                  </div>
                )}

                <div style={{ display: "flex", flexDirection: "column" }}>
                  <S.ContactItem>
                    <Tooltip
                      title={manager?.lider?.apelido || manager?.lider?.nome}
                      arrow
                    >
                      <S.TeamMemberName>
                        {manager?.lider?.apelido || manager?.lider?.nome}
                      </S.TeamMemberName>
                    </Tooltip>
                  </S.ContactItem>
                  <S.ContactItem>
                    <Tooltip
                      title={manager?.lider?.nome || manager?.lider?.apelido}
                      arrow
                    >
                      <S.TeamMemberRole>
                        {manager?.lider?.nome || manager?.lider?.apelido}
                      </S.TeamMemberRole>
                    </Tooltip>
                  </S.ContactItem>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <S.ContactItem
                    onClick={() => handleCopy(manager?.lider?.email)}
                  >
                    <PiMicrosoftOutlookLogo color="#127CD6" size={20} />
                    <Tooltip title={manager?.lider?.email} arrow>
                      <S.ContactInfoText style={{ color: "#666" }}>
                        {manager?.lider?.email}
                      </S.ContactInfoText>
                    </Tooltip>
                  </S.ContactItem>
                  {permittedInfos(manager) && (
                    <S.ContactItem
                      onClick={() =>
                        handleCopy(formatPhone(manager?.lider?.telefone))
                      }
                    >
                      <FaWhatsapp color="rgb(76, 175, 80)" size={20} />
                      <Tooltip title={manager?.lider?.telefone} arrow>
                        <S.ContactInfoText style={{ color: "#666" }}>
                          {formatPhone(manager?.lider?.telefone) ||
                            "Sem telefone"}
                        </S.ContactInfoText>
                      </Tooltip>
                    </S.ContactItem>
                  )}
                </div>
              </div>
            </S.ContactInfo>
          )}
          {idUsuarioLider && (
            <>
              {/* Se ainda estiver carregando detalhes da equipe */}
              {isLoadingCarometroDetalhe ? (
                <div
                  style={{
                    display: "flex",
                    marginTop: "16px",
                    justifyContent: "center",
                  }}
                >
                  <MaterialUI.CircularProgress
                    style={{ color: "blue" }}
                    size={22}
                  />
                </div>
              ) : (
                <>
                  {/* Exibir lista de equipe se houver */}
                  {carometroDetalhe?.data?.usuarios?.length > 0 && (
                    <>
                      <S.TeamHeading>Equipe</S.TeamHeading>

                      <InputRanking
                        handleBtnSearch={() => {}}
                        onChange={(e) => setDetailSearch(e.target.value)}
                        variant="outlined"
                        placeholder="Buscar Usuários"
                      />

                      <S.TeamGridWrapper>
                        <S.TeamGrid>
                          {filteredDetails.map((member: any) => (
                            <S.TeamMemberCard key={member.idUsuario}>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "16px",
                                  alignItems: "center",
                                }}
                              >
                                {member?.urlFoto ? (
                                  <S.TeamMemberAvatar
                                    src={member?.urlFoto || ""}
                                    alt={member?.nome || member?.apelido}
                                  />
                                ) : (
                                  <div
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      borderRadius: "50%",
                                      background: "#d3d3d3",
                                      border: "2px solid #808080",
                                    }}
                                  >
                                    <IconsSVG.UserIcon width={20} height={20} />
                                  </div>
                                )}
                                <S.TeamMemberInfo>
                                  <Tooltip
                                    title={member?.apelido || member?.nome}
                                    arrow
                                  >
                                    <S.TeamMemberName>
                                      {member?.apelido || member?.nome}
                                    </S.TeamMemberName>
                                  </Tooltip>
                                  <Tooltip
                                    title={member?.nome || member?.apelido}
                                    arrow
                                  >
                                    <S.TeamMemberRole>
                                      {member?.nome || member?.apelido}
                                    </S.TeamMemberRole>
                                  </Tooltip>
                                </S.TeamMemberInfo>
                              </div>

                              <div
                                style={{
                                  gap: "8px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  flexDirection: "column",
                                }}
                              >
                                <S.ContactItem
                                  onClick={() => handleCopy(member?.email)}
                                >
                                  <PiMicrosoftOutlookLogo
                                    color="#127CD6"
                                    size={20}
                                  />
                                  <Tooltip title={member?.email} arrow>
                                    <S.ContactInfoText
                                      style={{ color: "#666" }}
                                    >
                                      {member?.email || "Sem e-mail"}
                                    </S.ContactInfoText>
                                  </Tooltip>
                                </S.ContactItem>
                                {permittedInfos(member) && (
                                  <S.ContactItem
                                    onClick={() =>
                                      handleCopy(formatPhone(member?.telefone))
                                    }
                                  >
                                    <FaWhatsapp
                                      color="rgb(76, 175, 80)"
                                      size={20}
                                    />
                                    <Tooltip title={member?.telefone} arrow>
                                      <S.ContactInfoText
                                        style={{ color: "#666" }}
                                      >
                                        {formatPhone(member?.telefone) ||
                                          "Sem telefone"}
                                      </S.ContactInfoText>
                                    </Tooltip>
                                  </S.ContactItem>
                                )}
                              </div>
                            </S.TeamMemberCard>
                          ))}
                        </S.TeamGrid>
                      </S.TeamGridWrapper>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </S.ManagerDetails>
      </S.ManagerCard>
    );
  };

  return (
    <S.Content>
      <S.Container>
        {/* Header: Título "Destaques" + ícone de estrela */}
        <S.Header>
          <S.HeaderTitle>Carômetro</S.HeaderTitle>
          <IoIdCardOutline color="#1A49CC" size={24} />
        </S.Header>

        {/* Grid de Regionais */}
        <S.ManagerListWrapper>
          <S.ColumnsWrapper>
            {isLoadingCarometro ? (
              <div
                style={{
                  display: "flex",
                  marginTop: "16px",
                  justifyContent: "center",
                }}
              >
                <MaterialUI.CircularProgress
                  style={{ color: "blue" }}
                  size={36}
                />
              </div>
            ) : managersDisplayed.length > 0 ? (
              <>
                {managersDisplayed.map((manager: any) =>
                  renderManagerCard(manager)
                )}
              </>
            ) : (
              <div
                style={{
                  display: "flex",
                  marginTop: "16px",
                  justifyContent: "center",
                }}
              >
                <S.HeaderTitle>Nenhuma equipe encontrada</S.HeaderTitle>
              </div>
            )}
          </S.ColumnsWrapper>
        </S.ManagerListWrapper>

        {/* Botão fixo ao final (via position: sticky) */}
        <S.BottomButtonWrapper>
          <S.BottomButton href="/carometro">
            Ver todas as equipes &gt;
          </S.BottomButton>
        </S.BottomButtonWrapper>
      </S.Container>
    </S.Content>
  );
}

export default CarometroContent;
